// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Void from "../Data.Void/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Internal from "../Foreign.Generic.Internal/index.js";
import * as Foreign_Index from "../Foreign.Index/index.js";
import * as Foreign_NullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Record from "../Record/index.js";
import * as Record_Builder from "../Record.Builder/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var except = /* #__PURE__ */ Control_Monad_Except_Trans.except(Data_Identity.applicativeIdentity);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_List_Types.applicativeNonEmptyList);
var applicativeExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(applicativeExceptT);
var readString = /* #__PURE__ */ Foreign.readString(Data_Identity.monadIdentity);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Data_Monoid.monoidFn(Data_List_Types.monoidList));
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_List_Types.semigroupList);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorFn);
var map1 = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity));
var identity1 = /* #__PURE__ */ Control_Category.identity(Record_Builder.categoryBuilder);
var bindExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity);
var bind = /* #__PURE__ */ Control_Bind.bind(bindExceptT);
var index = /* #__PURE__ */ Foreign_Index.index(/* #__PURE__ */ Foreign_Index.indexString(Data_Identity.monadIdentity));
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorNonEmptyList);
var composeFlipped = /* #__PURE__ */ Control_Semigroupoid.composeFlipped(Record_Builder.semigroupoidBuilder);
var insert = /* #__PURE__ */ Record_Builder.insert()();
var alt = /* #__PURE__ */ Control_Alt.alt(/* #__PURE__ */ Control_Monad_Except_Trans.altExceptT(Data_List_Types.semigroupNonEmptyList)(Data_Identity.monadIdentity));
var composeKleisliFlipped = /* #__PURE__ */ Control_Bind.composeKleisliFlipped(bindExceptT);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Foreign_Object.traversableObject)(applicativeExceptT);
var map3 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var toUnfoldable = /* #__PURE__ */ Data_List.toUnfoldable(Data_Unfoldable.unfoldableArray);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(bindExceptT);
var unless = /* #__PURE__ */ Control_Applicative.unless(applicativeExceptT);
var readArray = /* #__PURE__ */ Foreign.readArray(Data_Identity.monadIdentity);
var fromFoldable = /* #__PURE__ */ Data_List.fromFoldable(Data_Foldable.foldableArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var sequence1 = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray)(applicativeExceptT);
var composeKleisli = /* #__PURE__ */ Control_Bind.composeKleisli(bindExceptT);
var TaggedObject = /* #__PURE__ */ (function () {
    function TaggedObject(value0) {
        this.value0 = value0;
    };
    TaggedObject.create = function (value0) {
        return new TaggedObject(value0);
    };
    return TaggedObject;
})();
var RecArg = /* #__PURE__ */ (function () {
    function RecArg(value0) {
        this.value0 = value0;
    };
    RecArg.create = function (value0) {
        return new RecArg(value0);
    };
    return RecArg;
})();
var PlainArg = /* #__PURE__ */ (function () {
    function PlainArg(value0) {
        this.value0 = value0;
    };
    PlainArg.create = function (value0) {
        return new PlainArg(value0);
    };
    return PlainArg;
})();
var voidEncode = {
    encode: Data_Void.absurd
};
var voidDecode = {
    decode: function (v) {
        return except(new Data_Either.Left(pure(new Foreign.ForeignError("Decode: void"))));
    }
};
var unitEncode = {
    encode: function (v) {
        return Foreign.unsafeToForeign([  ]);
    }
};
var unitDecode = {
    decode: function (v) {
        return pure1(Data_Unit.unit);
    }
};
var unArg = function (v) {
    if (v instanceof RecArg) {
        return v.value0;
    };
    if (v instanceof PlainArg) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Foreign.Generic.Class (line 280, column 1 - line 280, column 24): " + [ v.constructor.name ]);
};
var stringEncode = {
    encode: Foreign.unsafeToForeign
};
var stringDecode = {
    decode: readString
};
var numberEncode = {
    encode: Foreign.unsafeToForeign
};
var numberDecode = {
    decode: /* #__PURE__ */ Foreign.readNumber(Data_Identity.monadIdentity)
};
var intEncode = {
    encode: Foreign.unsafeToForeign
};
var intDecode = {
    decode: /* #__PURE__ */ Foreign.readInt(Data_Identity.monadIdentity)
};
var genericEncodeArgsNoArguments = {
    encodeArgs: function (v) {
        return mempty;
    }
};
var genericDecodeNoConstructors = {
    decodeOpts: function (opts) {
        return function (v) {
            return fail(new Foreign.ForeignError("No constructors"));
        };
    }
};
var genericDecodeArgsNoArguments = /* #__PURE__ */ (function () {
    return {
        decodeArgs: function (v) {
            return function (v1) {
                return function (v2) {
                    if (v2 instanceof Data_List_Types.Nil) {
                        return pure1({
                            result: Data_Generic_Rep.NoArguments.value,
                            rest: Data_List_Types.Nil.value,
                            next: v1
                        });
                    };
                    return fail(new Foreign.ForeignError("Too many constructor arguments"));
                };
            };
        },
        decodeSingleRecordArg: Data_Maybe.Nothing.value
    };
})();
var genericCountArgsNoArguments = {
    countArgs: function (v) {
        return new Data_Either.Left(Data_Generic_Rep.NoArguments.value);
    }
};
var genericCountArgsArgument = {
    countArgs: function (v) {
        return new Data_Either.Right(1);
    }
};
var foreignEncode = {
    encode: identity
};
var foreignDecode = {
    decode: pure1
};
var encodeWithOptions = function (dict) {
    return dict.encodeWithOptions;
};
var genericEncodeArgsArgument = function (dictEncodeWithOptions) {
    var encodeWithOptions1 = encodeWithOptions(dictEncodeWithOptions);
    return {
        encodeArgs: function (opts) {
            return function (v) {
                return Data_List.singleton(new PlainArg(encodeWithOptions1(opts)(v)));
            };
        }
    };
};
var genericEncodeArgsRecord = function (dictEncodeWithOptions) {
    var encodeWithOptions1 = encodeWithOptions(dictEncodeWithOptions);
    return {
        encodeArgs: function (opts) {
            return function (v) {
                return Data_List.singleton(new RecArg(encodeWithOptions1(opts)(v)));
            };
        }
    };
};
var encodeRecordWithOptions = function (dict) {
    return dict.encodeRecordWithOptions;
};
var encodeWithOptionsRecord = function () {
    return function (dictEncodeRecord) {
        var encodeRecordWithOptions1 = encodeRecordWithOptions(dictEncodeRecord);
        return {
            encodeWithOptions: function (opts) {
                var $283 = encodeRecordWithOptions1(Type_Proxy["Proxy"].value)(opts);
                return function ($284) {
                    return Foreign.unsafeToForeign($283($284));
                };
            }
        };
    };
};
var encodeWithOptionsRecord1 = /* #__PURE__ */ encodeWithOptionsRecord();
var encodeRecordNil = {
    encodeRecordWithOptions: function (v) {
        return function (v1) {
            return function (v2) {
                return Foreign_Object.empty;
            };
        };
    }
};
var encodeRecordCons = function () {
    return function (dictEncodeRecord) {
        var encodeRecordWithOptions1 = encodeRecordWithOptions(dictEncodeRecord);
        return function (dictIsSymbol) {
            var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
            var get = Record.get(dictIsSymbol)();
            return function (dictEncodeWithOptions) {
                var encodeWithOptions1 = encodeWithOptions(dictEncodeWithOptions);
                return {
                    encodeRecordWithOptions: function (v) {
                        return function (opts) {
                            return function (rec) {
                                var obj = encodeRecordWithOptions1(Type_Proxy["Proxy"].value)(opts)(rec);
                                var l = reflectSymbol(Type_Proxy["Proxy"].value);
                                return Foreign_Object.insert(opts.fieldTransform(l))(encodeWithOptions1(opts)(get(Type_Proxy["Proxy"].value)(rec)))(obj);
                            };
                        };
                    }
                };
            };
        };
    };
};
var encodeOpts = function (dict) {
    return dict.encodeOpts;
};
var genericEncodeNoConstructors = {
    encodeOpts: function (opts) {
        return function (a) {
            return encodeOpts(genericEncodeNoConstructors)(opts)(a);
        };
    }
};
var genericEncodeSum = function (dictGenericEncode) {
    var encodeOpts1 = encodeOpts(dictGenericEncode);
    return function (dictGenericEncode1) {
        var encodeOpts2 = encodeOpts(dictGenericEncode1);
        return {
            encodeOpts: function (v) {
                return function (v1) {
                    if (v1 instanceof Data_Generic_Rep.Inl) {
                        return encodeOpts1({
                            sumEncoding: v.sumEncoding,
                            unwrapSingleArguments: v.unwrapSingleArguments,
                            unwrapSingleRecordArguments: v.unwrapSingleRecordArguments,
                            fieldTransform: v.fieldTransform,
                            unwrapSingleConstructors: false
                        })(v1.value0);
                    };
                    if (v1 instanceof Data_Generic_Rep.Inr) {
                        return encodeOpts2({
                            sumEncoding: v.sumEncoding,
                            unwrapSingleArguments: v.unwrapSingleArguments,
                            unwrapSingleRecordArguments: v.unwrapSingleRecordArguments,
                            fieldTransform: v.fieldTransform,
                            unwrapSingleConstructors: false
                        })(v1.value0);
                    };
                    throw new Error("Failed pattern match at Foreign.Generic.Class (line 397, column 1 - line 401, column 85): " + [ v.constructor.name, v1.constructor.name ]);
                };
            }
        };
    };
};
var encodeArgs = function (dict) {
    return dict.encodeArgs;
};
var genericEncodeArgsProduct = function (dictGenericEncodeArgs) {
    var encodeArgs1 = encodeArgs(dictGenericEncodeArgs);
    return function (dictGenericEncodeArgs1) {
        var encodeArgs2 = encodeArgs(dictGenericEncodeArgs1);
        return {
            encodeArgs: function (opts) {
                return function (v) {
                    return append(encodeArgs1(opts)(v.value0))(encodeArgs2(opts)(v.value1));
                };
            }
        };
    };
};
var encode = function (dict) {
    return dict.encode;
};
var encodeWithOptionsOther = function (dictEncode) {
    var encode1 = encode(dictEncode);
    return {
        encodeWithOptions: function (v) {
            return encode1;
        }
    };
};
var identityEncode = function (dictEncode) {
    return {
        encode: (function () {
            var $285 = encode(dictEncode);
            return function ($286) {
                return $285(unwrap($286));
            };
        })()
    };
};
var maybeEncode = function (dictEncode) {
    return {
        encode: Data_Maybe.maybe(Foreign_NullOrUndefined["null"])(encode(dictEncode))
    };
};
var objectEncode = function (dictEncode) {
    var encode1 = encode(dictEncode);
    return {
        encode: (function () {
            var $287 = Foreign_Object.mapWithKey(function (v) {
                return encode1;
            });
            return function ($288) {
                return Foreign.unsafeToForeign($287($288));
            };
        })()
    };
};
var defaultOptions = /* #__PURE__ */ (function () {
    return {
        sumEncoding: new TaggedObject({
            tagFieldName: "tag",
            contentsFieldName: "contents",
            constructorTagTransform: identity
        }),
        unwrapSingleConstructors: false,
        unwrapSingleArguments: true,
        unwrapSingleRecordArguments: false,
        fieldTransform: identity
    };
})();
var recordEncode = function () {
    return function (dictEncodeRecord) {
        return {
            encode: encodeWithOptions(encodeWithOptionsRecord1(dictEncodeRecord))(defaultOptions)
        };
    };
};
var decodeWithOptions = function (dict) {
    return dict.decodeWithOptions;
};
var decodeSingleRecordArg = function (dict) {
    return dict.decodeSingleRecordArg;
};
var decodeRecordWithOptions = function (dict) {
    return dict.decodeRecordWithOptions;
};
var decodeWithOptionsRecord = function () {
    return function (dictDecodeRecord) {
        var decodeRecordWithOptions1 = decodeRecordWithOptions(dictDecodeRecord);
        return {
            decodeWithOptions: function (opts) {
                return map(map1(Data_Function.flip(Record_Builder.build)({})))(decodeRecordWithOptions1(Type_Proxy["Proxy"].value)(opts));
            }
        };
    };
};
var decodeWithOptionsRecord1 = /* #__PURE__ */ decodeWithOptionsRecord();
var recordDecode = function () {
    return function (dictDecodeRecord) {
        return {
            decode: decodeWithOptions(decodeWithOptionsRecord1(dictDecodeRecord))(defaultOptions)
        };
    };
};
var decodeRecordNil = {
    decodeRecordWithOptions: function (v) {
        return function (v1) {
            return function (v2) {
                return pure1(identity1);
            };
        };
    }
};
var decodeRecordCons = function () {
    return function (dictDecodeRecord) {
        var decodeRecordWithOptions1 = decodeRecordWithOptions(dictDecodeRecord);
        return function (dictIsSymbol) {
            var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
            var insert1 = insert(dictIsSymbol);
            return function (dictDecodeWithOptions) {
                var decodeWithOptions1 = decodeWithOptions(dictDecodeWithOptions);
                return function () {
                    return {
                        decodeRecordWithOptions: function (v) {
                            return function (opts) {
                                return function (f) {
                                    return bind(decodeRecordWithOptions1(Type_Proxy["Proxy"].value)(opts)(f))(function (builder) {
                                        var l = reflectSymbol(Type_Proxy["Proxy"].value);
                                        var l_transformed = opts.fieldTransform(l);
                                        return bind(index(f)(l_transformed))(function (f_) {
                                            return bind(Control_Monad_Except.mapExcept(lmap(map2(Foreign.ErrorAtProperty.create(l_transformed))))(decodeWithOptions1(opts)(f_)))(function (a) {
                                                return pure1(composeFlipped(builder)(insert1(Type_Proxy["Proxy"].value)(a)));
                                            });
                                        });
                                    });
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var decodeOpts = function (dict) {
    return dict.decodeOpts;
};
var genericDecodeSum = function (dictGenericDecode) {
    var decodeOpts1 = decodeOpts(dictGenericDecode);
    return function (dictGenericDecode1) {
        var decodeOpts2 = decodeOpts(dictGenericDecode1);
        return {
            decodeOpts: function (opts) {
                return function (f) {
                    var opts$prime = {
                        fieldTransform: opts.fieldTransform,
                        sumEncoding: opts.sumEncoding,
                        unwrapSingleArguments: opts.unwrapSingleArguments,
                        unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                        unwrapSingleConstructors: false
                    };
                    return alt(map1(Data_Generic_Rep.Inl.create)(decodeOpts1(opts$prime)(f)))(map1(Data_Generic_Rep.Inr.create)(decodeOpts2(opts$prime)(f)));
                };
            }
        };
    };
};
var decodeArgsArgument = function (dictDecodeWithOptions) {
    var decodeWithOptions1 = decodeWithOptions(dictDecodeWithOptions);
    return function (v) {
        return function (v1) {
            return function (v2) {
                if (v2 instanceof Data_List_Types.Cons) {
                    return bind(Control_Monad_Except.mapExcept(lmap(map2(Foreign.ErrorAtIndex.create(v1))))(decodeWithOptions1(v)(v2.value0)))(function (a) {
                        return pure1({
                            result: a,
                            rest: v2.value1,
                            next: v1 + 1 | 0
                        });
                    });
                };
                return fail(new Foreign.ForeignError("Not enough constructor arguments"));
            };
        };
    };
};
var genericDecodeArgsArgument = function (dictDecodeWithOptions) {
    return {
        decodeArgs: decodeArgsArgument(dictDecodeWithOptions),
        decodeSingleRecordArg: Data_Maybe.Nothing.value
    };
};
var genericDecodeArgsRecord = function (dictDecodeWithOptions) {
    var decodeWithOptions1 = decodeWithOptions(dictDecodeWithOptions);
    return {
        decodeArgs: decodeArgsArgument(dictDecodeWithOptions),
        decodeSingleRecordArg: new Data_Maybe.Just(function (options) {
            return function (i) {
                return map1(Data_Generic_Rep.Argument)(decodeWithOptions1(options)(i));
            };
        })
    };
};
var decodeArgs = function (dict) {
    return dict.decodeArgs;
};
var genericDecodeArgsProduct = function (dictGenericDecodeArgs) {
    var decodeArgs1 = decodeArgs(dictGenericDecodeArgs);
    return function (dictGenericDecodeArgs1) {
        var decodeArgs2 = decodeArgs(dictGenericDecodeArgs1);
        return {
            decodeArgs: function (opts) {
                return function (i) {
                    return function (xs) {
                        return bind(decodeArgs1(opts)(i)(xs))(function (v) {
                            return bind(decodeArgs2(opts)(v.next)(v.rest))(function (v1) {
                                return pure1({
                                    result: new Data_Generic_Rep.Product(v.result, v1.result),
                                    rest: v1.rest,
                                    next: v1.next
                                });
                            });
                        });
                    };
                };
            },
            decodeSingleRecordArg: Data_Maybe.Nothing.value
        };
    };
};
var decode = function (dict) {
    return dict.decode;
};
var decodeWithOptionsOther = function (dictDecode) {
    var decode2 = decode(dictDecode);
    return {
        decodeWithOptions: function (v) {
            return decode2;
        }
    };
};
var identityDecode = function (dictDecode) {
    return {
        decode: (function () {
            var $289 = map1(Data_Identity.Identity);
            var $290 = decode(dictDecode);
            return function ($291) {
                return $289($290($291));
            };
        })()
    };
};
var maybeDecode = function (dictDecode) {
    return {
        decode: Foreign_NullOrUndefined.readNullOrUndefined(decode(dictDecode))
    };
};
var objectDecode = function (dictDecode) {
    var decode2 = decode(dictDecode);
    return {
        decode: composeKleisliFlipped((function () {
            var $292 = Foreign_Object.mapWithKey(function (v) {
                return decode2;
            });
            return function ($293) {
                return sequence($292($293));
            };
        })())(Foreign_Generic_Internal.readObject)
    };
};
var decode1 = /* #__PURE__ */ decode(/* #__PURE__ */ objectDecode(foreignDecode));
var genericEncodeConstructor = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return function (dictGenericEncodeArgs) {
        var encodeArgs1 = encodeArgs(dictGenericEncodeArgs);
        return {
            encodeOpts: function (opts) {
                return function (v) {
                    var unwrapArguments = function (v1) {
                        return function (v2) {
                            if (v2.length === 0) {
                                return v1.noArgs;
                            };
                            var v3 = function (v4) {
                                if (v2.length === 1 && opts.unwrapSingleArguments) {
                                    return v1["default"](unArg(v2[0]));
                                };
                                return v1["default"](Foreign.unsafeToForeign(map3(unArg)(v2)));
                            };
                            if (v2.length === 1 && v2[0] instanceof RecArg) {
                                var $243 = Control_Monad_Except.runExcept(decode1(v2[0].value0));
                                if ($243 instanceof Data_Either.Right) {
                                    return v1.singleRecord($243.value0);
                                };
                                return v3(true);
                            };
                            return v3(true);
                        };
                    };
                    var encodeArgsArray = function (encoding) {
                        var $294 = unwrapArguments(encoding);
                        var $295 = encodeArgs1(opts);
                        return function ($296) {
                            return $294(toUnfoldable($295($296)));
                        };
                    };
                    var ctorName = reflectSymbol(Type_Proxy["Proxy"].value);
                    if (opts.unwrapSingleConstructors) {
                        return encodeArgsArray({
                            noArgs: Foreign.unsafeToForeign({}),
                            singleRecord: Foreign.unsafeToForeign,
                            "default": identity
                        })(v);
                    };
                    var encodedTag = Foreign_Object.singleton(opts.sumEncoding.value0.tagFieldName)(Foreign.unsafeToForeign(opts.sumEncoding.value0.constructorTagTransform(ctorName)));
                    var encodedArgs = encodeArgsArray({
                        noArgs: Foreign_Object.empty,
                        singleRecord: function (r) {
                            if (opts.unwrapSingleRecordArguments) {
                                return r;
                            };
                            return Foreign_Object.singleton(opts.sumEncoding.value0.contentsFieldName)(Foreign.unsafeToForeign(r));
                        },
                        "default": Foreign_Object.singleton(opts.sumEncoding.value0.contentsFieldName)
                    })(v);
                    return Foreign.unsafeToForeign(Foreign_Object.union(encodedTag)(encodedArgs));
                };
            }
        };
    };
};
var countArgs = function (dict) {
    return dict.countArgs;
};
var genericCountArgsProduct = function (dictGenericCountArgs) {
    var countArgs1 = countArgs(dictGenericCountArgs);
    return function (dictGenericCountArgs1) {
        var countArgs2 = countArgs(dictGenericCountArgs1);
        return {
            countArgs: function (v) {
                var v1 = countArgs2(Type_Proxy["Proxy"].value);
                var v2 = countArgs1(Type_Proxy["Proxy"].value);
                if (v2 instanceof Data_Either.Left && v1 instanceof Data_Either.Left) {
                    return new Data_Either.Left(new Data_Generic_Rep.Product(v2.value0, v1.value0));
                };
                if (v2 instanceof Data_Either.Left && v1 instanceof Data_Either.Right) {
                    return new Data_Either.Right(v1.value0);
                };
                if (v2 instanceof Data_Either.Right && v1 instanceof Data_Either.Left) {
                    return new Data_Either.Right(v2.value0);
                };
                if (v2 instanceof Data_Either.Right && v1 instanceof Data_Either.Right) {
                    return new Data_Either.Right(v2.value0 + v1.value0 | 0);
                };
                throw new Error("Failed pattern match at Foreign.Generic.Class (line 465, column 5 - line 469, column 40): " + [ v2.constructor.name, v1.constructor.name ]);
            }
        };
    };
};
var genericDecodeConstructor = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return function (dictGenericDecodeArgs) {
        var decodeArgs1 = decodeArgs(dictGenericDecodeArgs);
        var decodeSingleRecordArg1 = decodeSingleRecordArg(dictGenericDecodeArgs);
        return function (dictGenericCountArgs) {
            var countArgs1 = countArgs(dictGenericCountArgs);
            return {
                decodeOpts: function (opts) {
                    return function (f) {
                        var numArgs = countArgs1(Type_Proxy["Proxy"].value);
                        var readArguments = function (args) {
                            if (numArgs instanceof Data_Either.Left) {
                                return pure1(numArgs.value0);
                            };
                            if (numArgs instanceof Data_Either.Right && (numArgs.value0 === 1 && opts.unwrapSingleArguments)) {
                                return bind(decodeArgs1(opts)(0)(Data_List.singleton(args)))(function (v) {
                                    return discard(unless(Data_List["null"](v.rest))(fail(new Foreign.ForeignError("Expected a single argument"))))(function () {
                                        return pure1(v.result);
                                    });
                                });
                            };
                            if (numArgs instanceof Data_Either.Right) {
                                return bind(readArray(args))(function (vals) {
                                    return bind(decodeArgs1(opts)(0)(fromFoldable(vals)))(function (v) {
                                        return discard(unless(Data_List["null"](v.rest))(fail(new Foreign.ForeignError("Expected " + (show(numArgs.value0) + " constructor arguments")))))(function () {
                                            return pure1(v.result);
                                        });
                                    });
                                });
                            };
                            throw new Error("Failed pattern match at Foreign.Generic.Class (line 324, column 9 - line 336, column 24): " + [ numArgs.constructor.name ]);
                        };
                        var ctorName = reflectSymbol(Type_Proxy["Proxy"].value);
                        if (opts.unwrapSingleConstructors) {
                            return map1(Data_Generic_Rep.Constructor)(readArguments(f));
                        };
                        return bind(Control_Monad_Except.mapExcept(lmap(map2(Foreign.ErrorAtProperty.create(opts.sumEncoding.value0.tagFieldName))))(bind(bind(index(f)(opts.sumEncoding.value0.tagFieldName))(readString))(function (tag) {
                            var expected = opts.sumEncoding.value0.constructorTagTransform(ctorName);
                            return discard(unless(tag === expected)(fail(new Foreign.ForeignError("Expected " + (show1(expected) + " tag")))))(function () {
                                return pure1(tag);
                            });
                        })))(function (tag) {
                            return bind((function () {
                                if (decodeSingleRecordArg1 instanceof Data_Maybe.Just && opts.unwrapSingleRecordArguments) {
                                    return decodeSingleRecordArg1.value0(opts)(f);
                                };
                                return Control_Monad_Except.mapExcept(lmap(map2(Foreign.ErrorAtProperty.create(opts.sumEncoding.value0.contentsFieldName))))(bind(index(f)(opts.sumEncoding.value0.contentsFieldName))(readArguments));
                            })())(function (args) {
                                return pure1(args);
                            });
                        });
                    };
                }
            };
        };
    };
};
var charEncode = {
    encode: Foreign.unsafeToForeign
};
var charDecode = {
    decode: /* #__PURE__ */ Foreign.readChar(Data_Identity.monadIdentity)
};
var booleanEncode = {
    encode: Foreign.unsafeToForeign
};
var booleanDecode = {
    decode: /* #__PURE__ */ Foreign.readBoolean(Data_Identity.monadIdentity)
};
var arrayEncode = function (dictEncode) {
    return {
        encode: (function () {
            var $297 = map3(encode(dictEncode));
            return function ($298) {
                return Foreign.unsafeToForeign($297($298));
            };
        })()
    };
};
var arrayDecode = function (dictDecode) {
    var decode2 = decode(dictDecode);
    return {
        decode: (function () {
            var readElement = function (i) {
                return function (value) {
                    return Control_Monad_Except.mapExcept(lmap(map2(Foreign.ErrorAtIndex.create(i))))(decode2(value));
                };
            };
            var readElements = function (arr) {
                return sequence1(Data_Array.zipWith(readElement)(Data_Array.range(0)(Data_Array.length(arr)))(arr));
            };
            return composeKleisli(readArray)(readElements);
        })()
    };
};
export {
    countArgs,
    decode,
    decodeArgs,
    decodeOpts,
    decodeRecordWithOptions,
    decodeSingleRecordArg,
    decodeWithOptions,
    encode,
    encodeArgs,
    encodeOpts,
    encodeRecordWithOptions,
    encodeWithOptions,
    TaggedObject,
    defaultOptions,
    RecArg,
    PlainArg,
    unArg,
    decodeArgsArgument,
    voidDecode,
    unitDecode,
    foreignDecode,
    stringDecode,
    charDecode,
    booleanDecode,
    numberDecode,
    intDecode,
    identityDecode,
    arrayDecode,
    maybeDecode,
    objectDecode,
    recordDecode,
    voidEncode,
    unitEncode,
    foreignEncode,
    stringEncode,
    charEncode,
    booleanEncode,
    numberEncode,
    intEncode,
    identityEncode,
    arrayEncode,
    maybeEncode,
    objectEncode,
    recordEncode,
    decodeWithOptionsRecord,
    decodeWithOptionsOther,
    encodeWithOptionsRecord,
    encodeWithOptionsOther,
    decodeRecordNil,
    encodeRecordNil,
    decodeRecordCons,
    encodeRecordCons,
    genericDecodeNoConstructors,
    genericEncodeNoConstructors,
    genericDecodeConstructor,
    genericEncodeConstructor,
    genericDecodeSum,
    genericEncodeSum,
    genericDecodeArgsNoArguments,
    genericEncodeArgsNoArguments,
    genericDecodeArgsRecord,
    genericDecodeArgsArgument,
    genericEncodeArgsRecord,
    genericEncodeArgsArgument,
    genericDecodeArgsProduct,
    genericEncodeArgsProduct,
    genericCountArgsNoArguments,
    genericCountArgsArgument,
    genericCountArgsProduct
};
